<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu }">
      <v-btn icon v-on="{ ...menu }">
        <img :src="currentLanguageIcon" v-if="currentLanguageIcon" width="32" height="20" />
        <v-icon v-else>mdi-earth</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="language in languages"
        :key="language.id"
        @click="changeLanguage(language.id)"
      >
        <v-list-item-avatar tile size="32" height="20">
          <v-img :src="language.flagSrc"></v-img>
        </v-list-item-avatar>
        <v-list-item-title>{{ language.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import { bus } from '../main';

export default {
  name: "locale-changer",
  data: () => ({
    currentLanguage: null,
    languages: [      
      {
        id: "de",
        title: "German",
        flagSrc: "/img/flags/deu.png"
      },
      {
        id: "en",
        title: "English",
        flagSrc: "/img/flags/gbr.png"
      },
      {
        id: "es",
        title: "Spanish",
        flagSrc: "/img/flags/esp.png"
      },
      {
        id: "fr",
        title: "French",
        flagSrc: "/img/flags/fra.png"
      },
      {
        id: "it",
        title: "Italian",
        flagSrc: "/img/flags/ita.png"
      },
      {
        id: "nl",
        title: "Dutch",
        flagSrc: "/img/flags/nld.png"
      },
      {
        id: "pl",
        title: "Polish",
        flagSrc: "/img/flags/pol.png"
      },
      {
        id: "pt",
        title: "Portuguese",
        flagSrc: "/img/flags/prt.png"
      },
      {
        id: "ru",
        title: "Russian",
        flagSrc: "/img/flags/rus.png"
      }
    ]
  }),
  mounted: function() {
    let userLang = (navigator.language || navigator.userLanguage).substring(0, 2);
    let cookieLang = this.$cookies.get('locale');

    if(null !== cookieLang){
        this.changeLanguage(cookieLang);
        return;
    }

    if(userLang) {
        this.changeLanguage(userLang);
        return;
    }
  },
  computed: {
    currentLanguageIcon() {
      if (!this.currentLanguage) {
        return null;
      }
      return this.languages.filter(x => x.id === this.currentLanguage)[0]
        .flagSrc;
    }
  },
  methods: {
    changeLanguage(id) {
        this.currentLanguage = id;
        this.$i18n.locale = id;
        this.$cookies.set('locale', id, '365d');

        bus.$emit('refreshCountry');
    }
  }
};
</script>